import React from 'react';
import PropTypes from 'prop-types';
import MatchHeaderUpcoming from '../components/MatchDetails/MatchHeaderUpcoming';
import TeamForm from '../components/MatchDetails/TeamForm';
import MatchUpStandings from '../components/MatchDetails/MatchUpStandings';
import TeamNews from '../components/MatchDetails/TeamNews';
import TopPlayers from '../components/MatchDetails/TopPlayers';
import { LEAGUES } from '../constants/leagues';

function MatchDetailsUpcoming({
  match,
  homeTeamLogo,
  visitingTeamLogo,
  teamLogos,
}) {
  return (
    <>
      <MatchHeaderUpcoming
        match={match}
        homeTeamLogo={homeTeamLogo}
        visitingTeamLogo={visitingTeamLogo}
      />
      <div className="site-container">
        {match?.configLeagueName !== LEAGUES.FUTSAL && (
            <div className="col-12 text-center mb-4 d-none d-lg-block">
              <a href="/">
                <img
                    height="24"
                    src="/wp-content/themes/sef-leagues/images/discovery-plus-logo-white.svg"
                    alt=""
                />
              </a>
            </div>
        )}
        <TeamForm
            match={match}
            teamLogos={teamLogos}
            homeTeamLogo={homeTeamLogo}
            visitingTeamLogo={visitingTeamLogo}
        />
        <MatchUpStandings match={match} teamLogos={teamLogos} />
        <TeamNews
            teamLogo={homeTeamLogo}
            abbrv={match?.homeTeamAbbrv}
            teamName={match?.homeTeamName}
        />
        <TeamNews
            teamLogo={visitingTeamLogo}
            abbrv={match?.visitingTeamAbbrv}
            teamName={match?.visitingTeamName}
        />
        {match?.configLeagueName !== LEAGUES.FUTSAL && (
            <TopPlayers match={match} />
        )}
      </div>
    </>
  );
}

MatchDetailsUpcoming.propTypes = {
  match: PropTypes.shape({
    homeTeamAbbrv: PropTypes.string.isRequired,
    homeTeamName: PropTypes.string.isRequired,
    visitingTeamName: PropTypes.string.isRequired,
    visitingTeamAbbrv: PropTypes.string.isRequired,
  }).isRequired,
  homeTeamLogo: PropTypes.string.isRequired,
  visitingTeamLogo: PropTypes.string.isRequired,
  teamLogos: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default MatchDetailsUpcoming;
